import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

import { Arrow } from '../../../Common/Icon';
// import VideoEmpty from '../../../Common/Video/Empty';

import styles from './index.module.scss';
import Video from '../../../Common/Video';

function ShareYourTwoCents() {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.videoWrapper}>
            <Video
              src="/ShareYourTwoCents.mp4"
              poster="/media/whatIsTippingGuide.png"
            />
            {/* <VideoEmpty /> */}
          </div>
          <div className={styles.innerWrapper}>
            <h2 className={styles.title}>
              <span>
                <span className="colorGreen">Share</span> Your
              </span>
              <span> Two Cents</span>
            </h2>
            <p className={styles.description}>
              Frustrated with tip screens and service fees?
              <br />
              Share your experience here!
            </p>

            <div>
              <Button
                icon={<Arrow />}
                type="primary"
                size="large"
                className={styles.button}
                onClick={() => navigate('/share-your-two-cents')}
              >
                Share now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShareYourTwoCents;
